module.exports = __webpack_public_path__ + "img/E5DED7_AFA69D_C4BCB4_C3BAAB-256px.3c54f6ca.png";